export default function Indent({ children }) {
  return <div style={{ marginLeft: '24px' }}>{children}</div>;
}
